import type { AvailabilityContainers } from '@elara/client-core/lib/item-availability';

import { isItemUnavailable } from '@elara/client-core/lib/item-availability';

import { useApp, useTripsState } from '#states/hooks.js';

/**
 * Web hook wrapper around the shared `isItemUnavailable` predicate (moved to
 * `@elara/client-core/lib/item-availability`, ELARA-708 follow-up, so mobile can use the exact same
 * logic). Only the `useTripsState()`/`useApp('features')` binding stays web-specific.
 */
export function useItemAvailability(
  itemType: string,
  referenceId: string | undefined,
  metadata?: Record<string, unknown>,
): boolean {
  const tripsState = useTripsState();
  const tripId = tripsState.current?.id;
  const { features } = useApp('features');

  return isItemUnavailable(itemType, referenceId, metadata, tripId, features as unknown as AvailabilityContainers);
}
